import { Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { ToggleThemeButton, useStore } from "react-admin";

import { type ThemeName, themes } from "./themes";

const ucFirst = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const ThemeSwapper = () => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClose = () => {
		setAnchorEl(null);
	};

	const [themeName, setThemeName] = useStore<ThemeName>("themeName", "soft");
	const handleChange = (
		_: Readonly<React.MouseEvent<HTMLElement>>,
		index: number,
	) => {
		const newTheme = themes[index];
		if (!newTheme) {
			throw Error("Theme should not be undefined");
		}
		setThemeName(newTheme.name);
		setAnchorEl(null);
	};
	const currentTheme = themes.find((theme) => theme.name === themeName);

	const shouldDisplayToggle = currentTheme?.dark;

	return (
		<>
			{shouldDisplayToggle ? <ToggleThemeButton /> : null}
			<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
				{themes.map((theme, index: number) => (
					<MenuItem
						onClick={(event) => {
							handleChange(event, index);
						}}
						value={theme.name}
						key={theme.name}
						selected={theme.name === themeName}
					>
						{ucFirst(theme.name)}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};
